var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnFollowActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#24C062;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.2,6.1c-1.5-1.5-4-1.5-5.5,0c-1.5,1.5-1.5,3.9-0.1,5.4l7.1,7.5c0.1,0.1,0.3,0.1,0.4,0l7.1-7.5 c1.5-1.5,1.4-4-0.1-5.4c-1.5-1.5-4-1.5-5.5,0l-1.2,1.2c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2L10.2,6.1z M3.6,5.1 C5.7,3,9.1,3,11.2,5.1l0.7,0.7l0.7-0.7c2.1-2.1,5.5-2.1,7.6,0c2.1,2.1,2.1,5.4,0.1,7.5l-7.1,7.5c-0.7,0.7-1.8,0.7-2.5,0l-7.1-7.5 C1.5,10.5,1.5,7.2,3.6,5.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFollowActive);
export default __webpack_public_path__ + "static/media/icn_follow-active.b749f72b0b00932c6d950a1381fd1387.svg";
export { ForwardRef as ReactComponent };